module.exports = __webpack_public_path__ + "static/media/Component_1.de467309.png";